import { useEffect } from "react";

import { useAuthContext } from "@/components/AuthProvider";
import Loading from "@/components/Loading";
import OtpSetup from "@/components/otp/OtpSetup";
import OtpVerify from "@/components/otp/OtpVerify";
import { needsOtpAction } from "@/hooks/useOtpApi";

export default function OtpGate({ children }) {
  const { user, otp, refreshAuth } = useAuthContext();
  const action = user ? needsOtpAction(otp) : null;

  useEffect(() => {
    if (user && otp === null) {
      refreshAuth();
    }
  }, [user, otp, refreshAuth]);

  if (user && (otp === undefined || otp === null)) {
    return <Loading />;
  }

  if (action === "setup") {
    return <OtpSetup required fullPage />;
  }

  if (action === "verify") {
    return <OtpVerify />;
  }

  return children;
}
